import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import axios from "src/app/Service/axios";
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute } from '@angular/router';
import { EChartsOption } from 'echarts';
declare let $: any;

@Component({

  selector: 'app-trip-drivers',

  templateUrl: './trip-drivers.component.html',

  styleUrls: ['./trip-drivers.component.css']

})

export class TripDriversComponent implements OnInit {

  biorhythmData: any = {};

  list_Drivers: any = [];

  lst_Search = [];

  bUser_Biorhythm: boolean = false;

  options!: EChartsOption;

  lineBar!: EChartsOption;

  lineChartData: any = {};

  obj_Driver: any = {};

  mdl_Search: FormGroup = this._fb.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitID: new FormControl('', Validators.required),

    strBirthDate: new FormControl('', Validators.required),

    _index: new FormControl('')

  })

  constructor(

    private _fb: FormBuilder,

    private gurdService: GurdServiceService,

    private _tooltip: NotificationService,

    private _other: OtherService,

    private _router: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this._router.paramMap.subscribe(params => {

      if (params.get('strUnitID')) {

        this.bUser_Biorhythm = true;

        this.mdl_Search.controls['strUnitID'].setValue(params.get('strUnitID'));

        this.get_Biorhythm();

        this.get_Chart();

      }

      else {

        this.getAll_Driver();

      }


    });

  }

  async getAll_Driver() {

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`School_Mobile_Search`, this.mdl_Search.value)).data.toString());

    this._other.nonespinner()

    this.list_Drivers = res.dtMobile;

    this.lst_Search = res.dtMobile;


  }

  filter_list(val: any) {

    this.list_Drivers = this.lst_Search.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strPersonnelID.trim().toString().includes(val.value) ||

        el.strMobile.trim().toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Drivers = this.lst_Search;

    }

  }

  show_Biorhythm(item: any, index?: number) {

    if (item.strBirthDate.trim() == '') {

      this.mdl_Search.controls['strBirthDate'].setValue('')

      this.mdl_Search.controls['strUnitID'].setValue(item.strUnitID.trim())

      this.mdl_Search.controls['_index'].setValue(index)

      return $('#Biorhythm_Modal').modal('show')

    }

    else {

      window.open(`trip/dashboard/search-driver/${item.strUnitID.trim()}`, '_blank')

    }

  }

  async submit_BirthDate() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('تاریخ تولد را وارد کنید');

    else {

      this._other.Showspinner()

      let res = JSON.parse((await axios.post(`Mobile_UpdatestrBirthDate`, this.mdl_Search.value)).data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('با موفقیت ویرایش شد');

      this.list_Drivers[this.mdl_Search.get('_index')?.value].strBirthDate = this.mdl_Search.get('strBirthDate')?.value;

      this.show_Biorhythm({ strUnitID: this.mdl_Search.get('strUnitID')?.value, strBirthDate: 'validate' });

      $('#Biorhythm_Modal').modal('hide');


    }

  }

  async get_Biorhythm() {

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Mobile_Biorhythm`, this.mdl_Search.value)).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.biorhythmData = res;

    this.graph(res[0].PhysicalIndex, res[0].EmotionalIndex, res[0].IntellectualIndex);

  }

  async get_Chart() {

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Mobile_BiorhythmCharts`, this.mdl_Search.value)).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lineChartData = res;

    this.graph2();

  }

  show_Info(item: any) {

    this.obj_Driver = item;

    $("#Info_Modal").modal('show');

  }

  graph(a: any, b: any, c: any) {

    this.options = {

      legend: {
        align: 'auto',
        bottom: 10,
        textStyle: {
          color: '#000',
          fontFamily: 'vazir'
        },
      },

      title: {
        left: '50%',
        text: '',
        textStyle: {
          color: '#000',
          fontFamily: 'vazir'
        },
        textAlign: 'center',
      },

      tooltip: {

        trigger: "item",
        textStyle: {
          color: '#000',
          fontFamily: 'vazir'
        },


        formatter: function (params: any) {
          let number = new Number(params.value).toLocaleString('fa-ir');
          // return `${params.name} : %${number}`;
          return `${params.name}`;

        }
      },

      xAxis: {

        type: 'category',

        data: [`سطح انرژی جسمانی ( ${a.toLocaleString('fa-ir')} % )`, `سطح انرژی احساسی و عاطفی ( ${b.toLocaleString('fa-ir')} % )`, `سطح انرژی ذهنی و فکری ( ${c.toLocaleString('fa-ir')} % )`]
      },
      yAxis: {
        type: 'value',
        max: 100,
        min: -100,

      },

      axisLabel: {

        color: '#000',

        fontFamily: "vazir",


        formatter: function (params: any) {

          if (!isNaN(params)) {
            return new Number(params).toLocaleString('fa-ir')
          }

          if (isNaN(params)) {
            return params.toLocaleString('fa-ir')
          }

        }
      },
      series: [{
        data: [
          {
            value: a,
            itemStyle: { color: this.changeColor(a) },

          },
          {
            value: b,
            itemStyle: { color: this.changeColor(b) },

          },
          {
            value: c,
            itemStyle: { color: this.changeColor(c) },

          }
        ],

        type: 'bar',
        label: {
          fontFamily: 'vazir',
          formatter: function (params) {
            return new Number(params).toLocaleString('fa-ir')
          }
        },



      }]

    }

  }

  graph2() {

    const xAxisData: any = [];
    const data1: any = [];
    const data2: any = [];
    const data3: any = [];

    this.lineChartData.objBiorhythm_Emotional.forEach((a: any) => {

      xAxisData.push(a.strDate);

    })

    this.lineChartData.objBiorhythm_Physical.forEach((a: any) => {


      data1.push(a.dEnergyLevel);


    });

    this.lineChartData.objBiorhythm_Emotional.forEach((a: any) => {

      data2.push(a.dEnergyLevel);

    });

    this.lineChartData.objBiorhythm_Intellectual.forEach((a: any) => {


      data3.push(a.dEnergyLevel);

    })


    this.lineBar = {

      legend: {
        data: ['جسمی', 'عاطفی', 'فکری / هوشی'],
        align: 'left',
        textStyle: {
          color: '#000',
          fontFamily: "vazir"
        },
      },
      tooltip: {

        trigger: "item",
        textStyle: {
          color: '#000',
          fontFamily: "vazir"
        },
        formatter: function (params: any) {
          let number = new Number(params.value).toLocaleString('fa-ir');
          return `${params.seriesName}<br/><br/>  تاریخ :  ${params.name} <br/><br/> درصد :  ${number}`;

        }
      },
      axisLabel: {

        color: '#000',

        fontFamily: "vazir",


        formatter: function (params: any) {

          if (!isNaN(params)) {
            return new Number(params).toLocaleString('fa-ir')
          }

          if (isNaN(params)) {
            return params.toLocaleString('fa-ir')
          }

        }
      },
      xAxis: {
        data: xAxisData,
        silent: false,
        splitLine: {
          show: false,
        },
      },
      yAxis: {

        min: -100,
        max: 100
      },
      series: [
        {
          name: 'جسمی',
          type: 'line',
          data: data1,
          animationDelay: (idx) => idx * 100,
        },
        {
          name: 'عاطفی',
          type: 'line',
          data: data2,
          animationDelay: (idx) => idx * 10 + 200,
        },

        {
          name: 'فکری / هوشی',
          type: 'line',
          data: data3,
          animationDelay: (idx) => idx * 10 + 300,
        },
      ],
      animationEasing: 'elasticOut',

      animationDelayUpdate: (idx) => idx * 5,

    }

  }

  changeColor(number: any): any {

    if (number >= 0 && number <= 20) {
      return '#33cc33'
    }

    if (number >= 21 && number <= 40) {
      return '#85e085'
    }

    if (number >= 41 && number <= 60) {
      return '#c2f0c2'
    }

    if (number >= 61 && number <= 80) {
      return '#d6f5d6'
    }

    if (number >= 81 && number <= 100) {
      return '#ebfaeb'
    }

    if (number <= 0 && number >= -20) {
      return '#ffebe6'
    }

    if (number <= -21 && number >= -40) {
      return '#ffc2b3'
    }

    if (number <= -41 && number >= -60) {
      return '#ff9980'
    }

    if (number <= -61 && number >= -80) {
      return '#ff704d'
    }

    if (number <= -81 && number >= -100) {
      return '#ff3300'
    }

  }


}
